module.exports = __webpack_public_path__ + "static/media/photo.136f8398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo.png
// module id = 868
// module chunks = 0